import { render } from "./avatar-msg-box.vue?vue&type=template&id=5619b513&scoped=true&ts=true"
import script from "./avatar-msg-box.vue?vue&type=script&lang=ts"
export * from "./avatar-msg-box.vue?vue&type=script&lang=ts"

import "./avatar-msg-box.vue?vue&type=style&index=0&id=5619b513&lang=scss&scoped=true"

import exportComponent from "D:\\project\\fantan\\h5\\fantan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5619b513"]])

export default __exports__